/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MessagingProvider } from "./MessagingProvider";
import {
  MessagingProviderFromJSON,
  MessagingProviderFromJSONTyped,
  MessagingProviderToJSON,
  MessagingProviderToJSONTyped,
} from "./MessagingProvider";

/**
 *
 * @export
 * @interface MessagingLinkCode
 */
export interface MessagingLinkCode {
  /**
   *
   * @type {string}
   * @memberof MessagingLinkCode
   */
  code: string;
  /**
   *
   * @type {Date}
   * @memberof MessagingLinkCode
   */
  expiresAt: Date;
  /**
   *
   * @type {MessagingProvider}
   * @memberof MessagingLinkCode
   */
  provider: MessagingProvider;
  /**
   *
   * @type {string}
   * @memberof MessagingLinkCode
   */
  destination: string;
}

/**
 * Check if a given object implements the MessagingLinkCode interface.
 */
export function instanceOfMessagingLinkCode(
  value: object
): value is MessagingLinkCode {
  if (!("code" in value) || value["code"] === undefined) return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("destination" in value) || value["destination"] === undefined)
    return false;
  return true;
}

export function MessagingLinkCodeFromJSON(json: any): MessagingLinkCode {
  return MessagingLinkCodeFromJSONTyped(json, false);
}

export function MessagingLinkCodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessagingLinkCode {
  if (json == null) {
    return json;
  }
  return {
    code: json["code"],
    expiresAt: new Date(json["expires_at"]),
    provider: MessagingProviderFromJSON(json["provider"]),
    destination: json["destination"],
  };
}

export function MessagingLinkCodeToJSON(json: any): MessagingLinkCode {
  return MessagingLinkCodeToJSONTyped(json, false);
}

export function MessagingLinkCodeToJSONTyped(
  value?: MessagingLinkCode | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    code: value["code"],
    expires_at: value["expiresAt"].toISOString(),
    provider: MessagingProviderToJSON(value["provider"]),
    destination: value["destination"],
  };
}
